import React from 'react';
import PropTypes from 'prop-types';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Table from '@mui/material/Table';
import Chip from '@mui/material/Chip';

import VpMediaTagsList from '@vp-ui/widgets/VpMediaTable/VpMediaTagsList';
import VpMediaInfoMenu from '@vp-ui/widgets/VpMediaTable/VpMediaInfoMenu';
import VpAttachmentInfoMenu from '@vp-ui/widgets/VpMediaTable/VpAttachmentInfoMenu';
import { VpMediaIcon, VpCheckbox, VpRadio } from '@vp-ui';
import { useMediaTableContext } from '@src/hooks';
import { connect } from 'react-redux';
import { getIsSelectingSsembleMedia } from '@src/redux/modules/ssemble';

const headCells = [
  { blank: true, id: 1 },
  { blank: true, id: 2 },
  { blank: true, id: 3 },
  {
    id: 'prompt',
    label: 'Prompt',
  },
  {
    id: 'type',
    label: 'Media Type',
  },
  {
    id: 'tags',
    label: 'Tags',
  },
  { blank: true, id: 4 },
];

// styles
const clickableStyles = {
  cursor: 'pointer',
};

const VpMediaSubTable = ({
  videos = [],
  attachments = [],
  onMediaRowClick,
  isSelectingSsembleMedia,
}) => {
  const { onMediaCheck, getIsMediaSelected, onMediaRadioCheck } = useMediaTableContext();

  const onCheckboxClick = (e, media) => {
    e.stopPropagation();
    onMediaCheck(media);
  };

  const onRadioClick = (e, media) => {
    e.stopPropagation();
    onMediaRadioCheck(media);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          {headCells.map((cell) =>
            cell.blank ? (
              <TableCell key={cell.id} padding="checkbox"></TableCell>
            ) : (
              <TableCell key={cell.id}>{cell.label}</TableCell>
            )
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {videos.map((media) => (
          <TableRow
            hover
            sx={clickableStyles}
            onClick={() => onMediaRowClick(media?.mediaId)}
            key={media?.mediaId}
          >
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox">
              {isSelectingSsembleMedia ? (
                <VpRadio
                  onClick={(e) => onRadioClick(e, media)}
                  checked={getIsMediaSelected(media?.mediaId)}
                />
              ) : (
                <VpCheckbox
                  onClick={(e) => onCheckboxClick(e, media)}
                  checked={getIsMediaSelected(media?.mediaId)}
                />
              )}
            </TableCell>
            <TableCell>
              <VpMediaIcon media={media} />
            </TableCell>
            <TableCell>{media?.label}</TableCell>
            <TableCell>
              <Chip label="video" />
            </TableCell>
            <TableCell>
              <VpMediaTagsList tags={media?.tags} />
            </TableCell>
            <TableCell>
              <VpMediaInfoMenu disableCustomizeThumbnail media={media} />
            </TableCell>
          </TableRow>
        ))}
        {!isSelectingSsembleMedia && attachments.map((attachment) => (
          <TableRow
            hover
            sx={clickableStyles}
            onClick={() => onMediaRowClick(attachment?.attachmentId)}
            key={attachment?.attachmentId}
          >
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox">
              <VpCheckbox
                onClick={(e) => onCheckboxClick(e, attachment)}
                checked={getIsMediaSelected(attachment?.attachmentId)}
              />
            </TableCell>
            <TableCell>
              <VpMediaIcon media={attachment} />
            </TableCell>
            <TableCell>{attachment.label}</TableCell>
            <TableCell>
              <Chip label={attachment.contentType} />
            </TableCell>
            <TableCell>
              <VpMediaTagsList tags={attachment?.tags} />
            </TableCell>
            <TableCell>
              <VpAttachmentInfoMenu media={attachment} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

VpMediaSubTable.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.object),
  attachments: PropTypes.arrayOf(PropTypes.object),
  isSelectingSsembleMedia: PropTypes.bool,
  onMediaRowClick: PropTypes.func
};

const mapStateToProps = (state) => ({
  isSelectingSsembleMedia: getIsSelectingSsembleMedia(state),
});

export default connect(mapStateToProps)(VpMediaSubTable);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaSubTable.jsx